import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.702} height={20} {...props}>
    <g data-name="Arcade 20">
      <g data-name="Component 32 155">
        <g data-name="Group 6373" fill="#feda00">
          <path
            data-name="Path 5775"
            d="M0 9.993A10.023 10.023 0 0 1 7.967.228a9.692 9.692 0 0 1 9.044 2.663 1.623 1.623 0 0 1 .362 2 2.235 2.235 0 0 1-.565.659c-1.6 1.273-3.2 2.531-4.811 3.791-.58.455-.588.9-.012 1.356q2.376 1.887 4.753 3.772a1.715 1.715 0 0 1 .136 2.8c-.2.189-.4.373-.616.544a9.974 9.974 0 0 1-16.04-5.987c-.111-.6-.147-1.219-.218-1.829Zm13.1-5.747a1.352 1.352 0 0 0-1.338-1.366h-.023a1.36 1.36 0 0 0 .009 2.719h.008A1.345 1.345 0 0 0 13.1 4.253v-.005Z"
          />
          <path
            data-name="Path 5776"
            d="M21.702 9.992a.906.906 0 1 1-.922-.89h.009a.908.908 0 0 1 .912.89Z"
          />
          <path
            data-name="Path 5777"
            d="M13.358 10.006a.906.906 0 0 1 .908-.9h.017a.9.9 0 1 1-.926.9Z"
          />
          <path
            data-name="Path 5778"
            d="M18.425 10.007a.9.9 0 0 1-.894.905.918.918 0 0 1-.915-.92.9.9 0 0 1 .885-.883.884.884 0 0 1 .924.898Z"
          />
        </g>
      </g>
      <path
        data-name="Path 5775"
        d="M1.649 10.51c-.132-.715-.174-1.446-.259-2.169a12.067 12.067 0 0 1 1.1-4.925A10.17 10.17 0 0 0 .001 9.988c.071.61.106 1.226.218 1.829a9.984 9.984 0 0 0 10.684 8.146 11.778 11.778 0 0 1-9.254-9.453Z"
        fill="#eba706"
      />
    </g>
  </svg>
);

export default SvgComponent;
